import { useState } from "react";
import Button from "../../../app/universalComponents/Button";
import Placeholder from "../../../assets/images/placeholderProfile.png";
import SectionLabel from "../../../app/universalComponents/SectionLabel";
import { logout } from "../../../app/auth/authService";

export default function UserBadge({ organiserName, organiserLogo }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div className="p-4">
            <SectionLabel>Account</SectionLabel>

            <div className="flex gap-2 rounded-sm border p-2">
                <img src={organiserLogo || Placeholder} alt="Profile" className="aspect-square w-8 shrink-0 rounded-sm object-cover"/>

                <div>
                    <p className="text-sm font-semibold">{organiserName}</p>
                    <p className="text-xs">organiser</p>
                </div>

                <div className="relative ml-auto">
                    <button type="button" aria-label="Account options" onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="px-2 text-2xl hover:opacity-50"
                    >
                        ⋮
                    </button>

                    {isMenuOpen && (
                        <div className="p-1 absolute left-full top-1/2 z-20 ml-2 w-32 -translate-y-1/2 rounded-sm border bg-white shadow-sm">
                            <Button isSecondary type="button" onClick={logout} className="w-full text-sm">
                                Logout
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}